import { ArrowDownRight, ArrowUpRight, Minus } from './icons';
import { formatCurrency } from '../domain/format';

interface MetricCardProps {
  label: string;
  value: number;
  baseline?: number;
  inverse?: boolean;
  context?: string;
}

export const MetricCard = ({
  label,
  value,
  baseline,
  inverse = false,
  context,
}: MetricCardProps) => {
  const delta = baseline === undefined ? null : value - baseline;
  const positive = delta !== null && (inverse ? delta < 0 : delta > 0);
  const neutral = delta === null || Math.abs(delta) < 1;
  const Icon = neutral ? Minus : positive ? ArrowUpRight : ArrowDownRight;

  return (
    <article className="metric-card">
      <p className="eyebrow">{label}</p>
      <strong className="metric-value">{formatCurrency(value, { compact: true })}</strong>
      {delta !== null ? (
        <p className={`metric-delta ${neutral ? '' : positive ? 'positive' : 'negative'}`}>
          <Icon aria-hidden="true" size={15} />
          {neutral ? 'No change' : `${formatCurrency(Math.abs(delta), { compact: true })} vs plan`}
        </p>
      ) : (
        <p className="metric-context">{context}</p>
      )}
    </article>
  );
};
